export function freeze<T>(o: T): T {
  return Object.freeze(o)
}
